import NewsletterForm from './newsletter-form'

export default NewsletterForm
